import React, { useState } from "react";
import "../../assets/css/responsive.css";
import "../../assets/css/offer.css";
import "../../assets/css/general.css";
import "../../assets/css/hamburger.css";
import "../../assets/css/interimResearche.css";

import NavBar from "../../components/general/NavBarApp.jsx";
import Card from "../../components/general/listCard.jsx";

import SearchBar from "../../components/general/searchBar.jsx";
import Footer from "../../components/general/footer.jsx";

const Offer = () => {
  const offers = [
    {
      id: 1,
      title: "Lucas Prochon",
      rating: "4",
      work: "Cuisinier",
      location: "Nice (06)",
      time: "Disponible immédiatement",
      img: "pdp2.png",
    },
    {
      id: 2,
      title: "Lucas Prochon",
      rating: "4",
      work: "Cuisinier",
      location: "Nice (06)",
      time: "En mission jusqu'au 12/01",
      // pas d'img ici
    },
    {
      id: 3,
      title: "Lucas Prochon",
      rating: "4",
      work: "Cuisinier",
      location: "Nice (06)",
      time: "En mission jusqu'au 12/01",
      img: "pdp2.png",
    },
    {
      id: 4,
      title: "Lucas Prochon",
      rating: "3",
      work: "Cuisinier",
      location: "Nice (06)",
      time: "Disponible immédiatement",
      img: "pdp2.png",
    },
    {
      id: 5,
      title: "Lucas Prochon",
      rating: "4",
      work: "Cuisinier",
      location: "Nice (06)",
      time: "Disponible immédiatement",
      // pas d'img ici
    },
    {
      id: 6,
      title: "Lucas Prochon",
      rating: "4",
      work: "Cuisinier",
      location: "Nice (06)",
      time: "En mission jusqu'au 12/01",
      img: "pdp2.png",
    },
    {
      id: 7,
      title: "Lucas Prochon",
      rating: "4",
      work: "Cuisinier",
      location: "Nice (06)",
      time: "Disponible immédiatement",
      // pas d'img ici
    },
    {
      id: 8,
      title: "Lucas Prochon",
      rating: "4",
      work: "Cuisinier",
      location: "Nice (06)",
      time: "En mission jusqu'au 12/01",
      img: "pdp2.png",
    },
  ];

  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="interim-research">
      <NavBar userType="entreprise" />
      <SearchBar />
      <Card
        offers={offers}
        listName="Résultats"
        variant="interim-search"
        link="/intern-profile"
      />
    </div>
  );
};
export default Offer;
